import { IQueryContext } from 'framework/context/IQueryContext';
import { IQueryResultWithMetadata, ISale, ISalesQueryMetadata, ISalesQueryParams } from 'gen/ApiClient';
import React from 'react';

export const SalesListQueryContext = React.createContext<IQueryContext<IQueryResultWithMetadata<ISale, ISalesQueryMetadata>, ISalesQueryParams>>(
	undefined as any
);
